import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { errorMessage } from './Login';
import AuthShell from '../components/AuthShell';
import { errorBox, input, label, link, primaryBtn } from '../components/authStyles';

const API_URL = process.env.REACT_APP_API_URL || '';

// Destino do link mágico do e-mail: valida o token e define nome + senha.
function SignupConfirm({ onLogin }) {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [checking, setChecking] = useState(true);
  const [loading, setLoading] = useState(false);
  const [linkError, setLinkError] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setLinkError('Link de cadastro incompleto.');
      setChecking(false);
      return;
    }
    axios
      .get(`${API_URL}/api/auth/signup/verify`, { params: { token } })
      .then(({ data }) => setEmail(data.email))
      .catch((err) => setLinkError(errorMessage(err, 'Link inválido.')))
      .finally(() => setChecking(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('As senhas não conferem.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.post(`${API_URL}/api/auth/signup/complete`, {
        token,
        full_name: fullName,
        password,
      });
      onLogin(data.access_token, data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(errorMessage(err, 'Não foi possível concluir o cadastro'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Concluir cadastro">
      {checking && <p className="text-sm text-slate-400">Validando link…</p>}

      {!checking && linkError && (
        <div>
          <div className={errorBox}>{linkError}</div>
          <p className="text-center text-sm">
            <Link to="/login" className={link}>Voltar e solicitar um novo link</Link>
          </p>
        </div>
      )}

      {!checking && !linkError && (
        <form onSubmit={submit} className="flex flex-col gap-4">
          {error && <div className={errorBox}>{error}</div>}
          <label className={label}>
            E-mail
            <input type="email" value={email} disabled autoComplete="username" className={input} />
          </label>
          <label className={label}>
            Nome completo
            <input type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required minLength={2} className={input} />
          </label>
          <label className={label}>
            Senha (mínimo 8 caracteres)
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} autoComplete="new-password" className={input} />
          </label>
          <label className={label}>
            Confirmar senha
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} autoComplete="new-password" className={input} />
          </label>
          <button type="submit" className={primaryBtn} disabled={loading}>
            {loading ? 'Criando conta…' : 'Criar conta'}
          </button>
        </form>
      )}
    </AuthShell>
  );
}

export default SignupConfirm;
